// Reports the app's real content height to whatever page is hosting us in an
// <iframe>, so the host can size the iframe to fit instead of giving it a
// fixed/vh-based height with its own internal scroll region. That nested
// scroll pattern is what triggers the iOS Safari bug where the last bit of
// content becomes unreachable (the dynamic toolbar shrinks the visible
// viewport without the layout's 100vh-based height recalculating in time).
//
// Host integration snippet lives in README-iframe-resize.md at the repo root.

import history from '../Store/history/history';

const MESSAGE_TYPE = 'rego:content-height';

let lastPostedHeight = 0;
let rafId = null;
let started = false;

function measure() {
  return Math.ceil(
    Math.max(
      document.documentElement.scrollHeight,
      document.body.scrollHeight
    )
  );
}

function postHeight() {
  rafId = null;
  const height = measure();

  if (height === lastPostedHeight) return;
  lastPostedHeight = height;

  window.parent.postMessage({ type: MESSAGE_TYPE, height }, '*');
}

function scheduleMeasure() {
  if (rafId) return;
  rafId = window.requestAnimationFrame(postHeight);
}

export function initIframeAutoResize() {
  if (started) return;
  if (window.self === window.top) return; // not embedded, nothing to report
  started = true;

  scheduleMeasure();

  const resizeObserver = new ResizeObserver(scheduleMeasure);
  resizeObserver.observe(document.documentElement);

  const mutationObserver = new MutationObserver(scheduleMeasure);
  mutationObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
  });

  window.addEventListener('load', scheduleMeasure);
  window.addEventListener('orientationchange', scheduleMeasure);
  history.listen(scheduleMeasure);
}
